import { map, scan } from "@pdfking/rfunc"
import selector from "./selector"

export default (
  el: Element | Element[] | string,
  classes: Record<string, boolean>
): Element[] => {
  return map((e: Element) => {
    scan(
      (check: boolean, clist: string) =>
        scan(
          (c: string) => e.classList[check ? "add" : "remove"](c),

          clist ? clist.split(" ") : []
        ),

      classes
    )
    return e
  }, selector(el))
}
